<template>
  <div>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">设备名称</v-col>
      <v-col :cols="9" v-if="activated">
        <span>{{deviceInfo.DEV_TEXT}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">故障描述</v-col>
      <v-col :cols="9" v-if="activated" style="font-size: 1.1rem;">
        <!-- <span v-if="alertInfo.code === '200' || alertInfo.code === 200" style="color:#67C23A;">{{alertInfo.text}}</span> -->
        <span style="color:#F56C6C;">{{alertInfo.text}}</span>
      </v-col>
    </v-row>
    <v-row v-if="activated && alertInfo.value">
      <v-col :cols="3" style="color:#9e9e9e;">警报值</v-col>
      <v-col :cols="9">
        <span>{{alertInfo.value}}{{alertInfo.unit ? alertInfo.unit : ''}}</span>
      </v-col>
    </v-row>
    <v-card outlined style="margin: 0 -10px;padding: 0 10px;position: relative;">
      <span
        style="
        position: absolute;
        top: -10px;
        background: #ffffff;
        padding: 0 5px;
        display: inline-block;"
      >
          告警
      </span>
      <v-row>
        <v-col :cols="3" style="color:#9e9e9e;">开始时间</v-col>
        <v-col :cols="9" v-if="activated">
          <span>{{$moment(alertInfo.alarm_begin_time).format("YYYY-MM-DD HH:mm:ss")}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="3" style="color:#9e9e9e;">持续时间</v-col>
        <v-col :cols="9" v-if="activated">
          <span>{{getTimeStr(alertInfo.alarm_span_time_s)}}</span>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col :cols="3" style="color:#9e9e9e;">备注</v-col>
      <v-col :cols="9" v-if="activated">
        <span>请相关工作人员及时处理!</span>
      </v-col>
    </v-row>
    <v-row v-if="recordInfo.IS_RESEND">
      <v-col :cols="3" style="color:#9e9e9e;">补发</v-col>
      <v-col :cols="9" v-if="activated">
        <span>√</span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    alertInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    recordInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    activated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    // 时间格式化
    getTimeStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    }
  }
}
</script>

<style scoped>

</style>
